import { CardsTableHeadArrowUp } from './CardsTableHeadArrowUp';
export default CardsTableHeadArrowUp;
